
import React from 'react';
import CheckBetLayout1 from './CheckBetLayout1';
import CheckBetLayout2 from '../my-bets-layout-2/checkbet-layout-2/CheckBetLayout2';
import { getConfiguration } from '../../utils';
import CheckBetLayout3 from '../my-bets-layout-3/checkbet-layout-3/CheckBetLayout3';

function CheckBet(props) {
    const conf = getConfiguration();
    const layoutVersion = conf.mbt ?? 'V1';

    let LayoutComponent;

    switch (layoutVersion) {
        case 'V1':
            LayoutComponent = CheckBetLayout1;
            break;
        case 'V2':
            LayoutComponent = CheckBetLayout2;
            break;
        case 'V3':
            LayoutComponent = CheckBetLayout3;
            break;
        default:
            LayoutComponent = CheckBetLayout1; 
    }

    return (
        <>
         <LayoutComponent {...props} />;
        </>
    );
}

export default CheckBet;

